var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyTableView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 129,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m42.99,115.43l84.27,0c0.47,0 0.94,-0.05 1.38,-0.14c0.45,0.09 0.92,0.14 1.38,0.14l48.15,0c3.58,0 6.49,-2.91 6.49,-6.49c0,-3.59 -2.91,-6.49 -6.49,-6.49l-5.55,0c-3.59,0 -6.49,-2.91 -6.49,-6.49c0,-3.59 2.9,-6.49 6.49,-6.49l17.59,0c3.58,0 6.49,-2.91 6.49,-6.49c0,-3.58 -2.91,-6.49 -6.49,-6.49l-20.38,0c3.58,0 6.49,-2.9 6.49,-6.49c0,-3.58 -2.91,-6.49 -6.49,-6.49l-59.27,0c3.58,0 6.48,-2.9 6.48,-6.49c0,-3.58 -2.88,-6.42 -6.46,-6.42l-52.76,0c-3.58,0 -6.49,2.91 -6.49,6.49c0,3.59 2.91,6.49 6.49,6.49l-37.04,0c-3.58,0 -6.49,2.91 -6.49,6.49c0,3.59 2.91,6.49 6.49,6.49l23.15,0c3.58,0 6.49,2.91 6.49,6.49c0,3.58 -2.91,6.49 -6.49,6.49l-37.04,0c-3.58,-0.05 -6.49,2.86 -6.49,6.44c0,3.59 2.91,6.49 6.49,6.49l36.1,0c-3.58,0 -6.49,2.91 -6.49,6.49c0,3.56 2.91,6.47 6.49,6.47z",
    fill: "#F1F3F3",
    id: "svg_1",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.53,115.43c3.59,0 6.49,-2.91 6.49,-6.49c0,-3.59 -2.9,-6.49 -6.49,-6.49c-3.58,0 -6.49,2.9 -6.49,6.49c0,3.58 2.91,6.49 6.49,6.49z",
    fill: "#F1F3F3",
    id: "svg_2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.29,128.24l-55.08,0c-1.99,0 -3.61,-1.62 -3.61,-3.61l0,-73.04c0,-2 1.62,-3.61 3.61,-3.61l55.08,0c1.99,0 3.6,1.61 3.6,3.61l0,73.04c0.03,1.99 -1.59,3.61 -3.6,3.61z",
    fill: "#eb672d",
    id: "svg_3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.98,125.62l-54.44,0c-0.73,0 -1.32,-0.59 -1.32,-1.31l0,-72.39c0,-0.73 0.59,-1.32 1.32,-1.32l54.44,0c0.73,0 1.31,0.59 1.31,1.32l0,72.39c0,0.72 -0.58,1.31 -1.31,1.31z",
    fill: "#d37e5d",
    id: "svg_4",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.98,50.6l-54.44,0c-0.73,0 -1.32,0.59 -1.32,1.32l0,14.22l57.05,0l0,-14.22c0.02,-0.73 -0.56,-1.32 -1.29,-1.32z",
    fill: "#ea9a77",
    id: "svg_5",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.86,60.19c-1,0 -1.82,-0.82 -1.82,-1.83c0,-1.01 0.79,-1.81 1.8,-1.81l0.02,0c1.01,0 1.81,0.82 1.81,1.83c0,0.99 -0.82,1.81 -1.81,1.81z",
    fill: "#d3dbdc",
    id: "svg_6",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.84,60.19c-1.01,0 -1.83,-0.82 -1.83,-1.83c0,-1.01 0.8,-1.81 1.8,-1.81l0.03,0c1,0 1.8,0.82 1.8,1.83c0,0.99 -0.82,1.81 -1.8,1.81z",
    fill: "#d3dbdc",
    id: "svg_7",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.81,60.19c-1.01,0 -1.83,-0.82 -1.83,-1.83c0,-1.01 0.8,-1.81 1.81,-1.81l0.02,0c1.01,0 1.81,0.82 1.81,1.83c0,0.99 -0.82,1.81 -1.81,1.81z",
    fill: "#d3dbdc",
    id: "svg_8",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.81,74.83l-11.95,0c-1,0 -1.8,-0.82 -1.8,-1.81c0,-1 0.82,-1.8 1.8,-1.8l11.95,0c1.01,0 1.8,0.82 1.8,1.8c0,0.99 -0.79,1.81 -1.8,1.81z",
    fill: "#e85a1e",
    id: "svg_9",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.81,83.52l-11.95,0c-1,0 -1.8,-0.82 -1.8,-1.8c0,-1.01 0.82,-1.81 1.8,-1.81l11.95,0c1.01,0 1.8,0.82 1.8,1.81c0,0.98 -0.79,1.8 -1.8,1.8z",
    fill: "#d3dbdc",
    id: "svg_10",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.81,92.21l-11.95,0c-1,0 -1.8,-0.82 -1.8,-1.8c0,-1.01 0.82,-1.81 1.8,-1.81l11.95,0c1.01,0 1.8,0.82 1.8,1.81c0,0.98 -0.79,1.8 -1.8,1.8z",
    fill: "#e85a1e",
    id: "svg_11",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.81,100.9l-11.95,0c-1,0 -1.8,-0.82 -1.8,-1.8c0,-1.01 0.82,-1.81 1.8,-1.81l11.95,0c1.01,0 1.8,0.82 1.8,1.81c0,1.01 -0.79,1.8 -1.8,1.8z",
    fill: "#d3dbdc",
    id: "svg_12",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.81,109.59l-11.95,0c-1,0 -1.8,-0.82 -1.8,-1.8c0,-1.01 0.82,-1.81 1.8,-1.81l11.95,0c1.01,0 1.8,0.83 1.8,1.81c0,1.01 -0.79,1.8 -1.8,1.8z",
    fill: "#e85a1e",
    id: "svg_13",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.81,118.29l-11.95,0c-1,0 -1.8,-0.82 -1.8,-1.81c0,-1.01 0.82,-1.8 1.8,-1.8l11.95,0c1.01,0 1.8,0.82 1.8,1.8c0,1.01 -0.79,1.81 -1.8,1.81z",
    fill: "#d3dbdc",
    id: "svg_14",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.42,74.83l-11.95,0c-1.01,0 -1.8,-0.82 -1.8,-1.81c0,-1 0.82,-1.8 1.8,-1.8l11.95,0c1.01,0 1.8,0.82 1.8,1.8c0,0.99 -0.79,1.81 -1.8,1.81z",
    fill: "#e85a1e",
    id: "svg_15",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.42,83.52l-11.95,0c-1.01,0 -1.8,-0.82 -1.8,-1.8c0,-1.01 0.82,-1.81 1.8,-1.81l11.95,0c1.01,0 1.8,0.82 1.8,1.81c0,0.98 -0.79,1.8 -1.8,1.8z",
    fill: "#d3dbdc",
    id: "svg_16",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.42,92.21l-11.95,0c-1.01,0 -1.8,-0.82 -1.8,-1.8c0,-1.01 0.82,-1.81 1.8,-1.81l11.95,0c1.01,0 1.8,0.82 1.8,1.81c0,0.98 -0.79,1.8 -1.8,1.8z",
    fill: "#e85a1e",
    id: "svg_17",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.42,100.9l-11.95,0c-1.01,0 -1.8,-0.82 -1.8,-1.8c0,-1.01 0.82,-1.81 1.8,-1.81l11.95,0c1.01,0 1.8,0.82 1.8,1.81c0,1.01 -0.79,1.8 -1.8,1.8z",
    fill: "#d3dbdc",
    id: "svg_18",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.42,109.59l-11.95,0c-1.01,0 -1.8,-0.82 -1.8,-1.8c0,-1.01 0.82,-1.81 1.8,-1.81l11.95,0c1.01,0 1.8,0.83 1.8,1.81c0,1.01 -0.79,1.8 -1.8,1.8z",
    fill: "#e85a1e",
    id: "svg_19",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.42,118.29l-11.95,0c-1.01,0 -1.8,-0.82 -1.8,-1.81c0,-1.01 0.82,-1.8 1.8,-1.8l11.95,0c1.01,0 1.8,0.82 1.8,1.8c0,1.01 -0.79,1.81 -1.8,1.81z",
    fill: "#d3dbdc",
    id: "svg_20",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.21,128.28c1.38,0 2.5,-1.12 2.5,-2.5c0,-1.39 -1.12,-2.5 -2.5,-2.5c-1.38,0 -2.5,1.11 -2.5,2.5c0,1.38 1.12,2.5 2.5,2.5z",
    fill: "#f7bfa8",
    id: "svg_21",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.13,114l2.21,-2.21c0.88,-0.87 0.88,-2.28 0,-3.13c-0.88,-0.88 -2.28,-0.88 -3.13,0l-2.21,2.2l-2.21,-2.2c-0.87,-0.88 -2.28,-0.88 -3.13,0c-0.88,0.88 -0.88,2.28 0,3.13l2.21,2.21l-2.09,2.08c-0.87,0.88 -0.87,2.28 0,3.14c0.88,0.87 2.29,0.87 3.14,0l2.08,-2.08l2.08,2.08c0.88,0.87 2.28,0.87 3.14,0c0.87,-0.88 0.87,-2.29 0,-3.14l-2.09,-2.08z",
    fill: "#f7bfa8",
    id: "svg_22",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.93,38.63l2.06,-2.06c0.82,-0.82 0.82,-2.13 0,-2.93c-0.82,-0.82 -2.13,-0.82 -2.93,0l-2.06,2.06l-2.06,-2.06c-0.82,-0.82 -2.13,-0.82 -2.93,0c-0.82,0.82 -0.82,2.13 0,2.93l2.06,2.06l-1.94,1.95c-0.82,0.82 -0.82,2.13 0,2.93c0.82,0.82 2.13,0.82 2.93,0l1.94,-1.95l1.95,1.95c0.82,0.82 2.13,0.82 2.93,0c0.82,-0.82 0.82,-2.14 0,-2.93l-1.95,-1.95z",
    fill: "#f7bfa8",
    id: "svg_23",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.44,66.37c-2.21,0 -4,1.78 -4,4c0,2.22 1.79,4 4,4c2.22,0 4,-1.78 4,-4c0,-2.22 -1.78,-4 -4,-4zm0,5.45c-0.79,0 -1.45,-0.64 -1.45,-1.45c0,-0.82 0.64,-1.45 1.45,-1.45c0.82,0 1.46,0.63 1.46,1.45c0,0.81 -0.64,1.45 -1.46,1.45z",
    fill: "#f7bfa8",
    id: "svg_24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.53,54.7c-2.03,0 -3.68,1.64 -3.68,3.68c0,2.04 1.65,3.68 3.68,3.68c2.04,0 3.68,-1.64 3.68,-3.68c-0.02,-2.04 -1.66,-3.68 -3.68,-3.68zm0,4.99c-0.72,0 -1.33,-0.58 -1.33,-1.33c0,-0.75 0.58,-1.34 1.33,-1.34c0.75,0 1.34,0.59 1.34,1.34c0,0.75 -0.61,1.33 -1.34,1.33z",
    fill: "#f7bfa8",
    id: "svg_25",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.97,0c-1.15,0 -2.1,0.98 -2.1,2.18l0,14.62c0,1.19 0.95,2.18 2.1,2.18c1.15,0 2.1,-0.99 2.1,-2.18l0,-14.62c0,-1.2 -0.95,-2.18 -2.1,-2.18z",
    fill: "#f7bfa8",
    id: "svg_26",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.46,4.47c-0.77,-0.89 -2.1,-0.98 -2.96,-0.18c-0.85,0.79 -0.94,2.18 -0.18,3.07l9.33,10.84c0.77,0.89 2.1,0.99 2.96,0.19c0.86,-0.8 0.95,-2.18 0.18,-3.07l-9.33,-10.85z",
    fill: "#f7bfa8",
    id: "svg_27",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.3,4.31c-0.86,-0.8 -2.19,-0.73 -2.96,0.19l-9.35,10.85c-0.77,0.89 -0.7,2.27 0.18,3.06c0.86,0.8 2.19,0.73 2.96,-0.18l9.33,-10.85c0.79,-0.89 0.7,-2.27 -0.16,-3.07z",
    fill: "#f7bfa8",
    id: "svg_28",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.69,106.27l-55.08,0c-1.99,0 -3.61,-1.62 -3.61,-3.61l0,-73.05c0,-1.99 1.62,-3.61 3.61,-3.61l55.08,0c1.99,0 3.6,1.62 3.6,3.61l0,73.05c0,1.99 -1.61,3.61 -3.6,3.61z",
    fill: "#eb672d",
    id: "svg_29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.36,103.62l-54.42,0c-0.73,0 -1.32,-0.59 -1.32,-1.31l0,-72.39c0,-0.73 0.59,-1.31 1.32,-1.31l54.44,0c0.73,0 1.31,0.58 1.31,1.31l0,72.39c-0.02,0.72 -0.61,1.31 -1.33,1.31z",
    fill: "#FCFDFD",
    id: "svg_30",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.36,28.63l-54.42,0c-0.73,0 -1.32,0.58 -1.32,1.31l0,14.22l57.05,0l0,-14.22c0,-0.73 -0.59,-1.31 -1.31,-1.31z",
    fill: "#eb672d",
    id: "svg_31",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.26,78.04c-0.42,0 -0.84,-0.14 -1.17,-0.45c-0.82,-0.7 -1.97,-1.1 -3.19,-1.1c0,0 0,0 -0.02,0c-1.2,0 -2.37,0.4 -3.16,1.08c-0.78,0.65 -1.9,0.54 -2.56,-0.21c-0.66,-0.78 -0.54,-1.9 0.21,-2.56c1.48,-1.24 3.42,-1.92 5.51,-1.92l0.02,0c2.09,0 4.05,0.71 5.53,1.97c0.75,0.66 0.84,1.78 0.21,2.55c-0.37,0.43 -0.87,0.64 -1.38,0.64z",
    fill: "#eb672d",
    id: "svg_32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.3,69.81c-1.01,0 -1.83,-0.82 -1.83,-1.82c0,-1.01 0.8,-1.81 1.8,-1.81l0.03,0c1,0 1.8,0.82 1.8,1.83c0,1.01 -0.8,1.8 -1.8,1.8z",
    fill: "#eb672d",
    id: "svg_33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133,69.81c-1.01,0 -1.83,-0.82 -1.83,-1.82c0,-1.01 0.8,-1.81 1.81,-1.81l0.02,0c1.01,0 1.8,0.82 1.8,1.83c0,1.01 -0.79,1.8 -1.8,1.8z",
    fill: "#eb672d",
    id: "svg_34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.97,38.21c-0.03,0 -0.03,0 0,0c-1.01,0 -1.83,-0.82 -1.83,-1.83c0,-1 0.79,-1.8 1.8,-1.8l0.03,0c1,0 1.8,0.82 1.8,1.83c0,0.98 -0.82,1.8 -1.8,1.8z",
    fill: "#d3dbdc",
    id: "svg_35",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.94,38.21c-0.02,0 -0.02,0 0,0c-1.01,0 -1.83,-0.82 -1.83,-1.83c0,-1 0.8,-1.8 1.81,-1.8l0.02,0c1.01,0 1.8,0.82 1.8,1.83c0,0.98 -0.82,1.8 -1.8,1.8z",
    fill: "#d3dbdc",
    id: "svg_36",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.91,38.21c-0.02,0 -0.02,0 0,0c-1,0 -1.82,-0.82 -1.82,-1.83c0,-1 0.79,-1.8 1.8,-1.8l0.02,0c1.01,0 1.81,0.82 1.81,1.83c0,0.98 -0.82,1.8 -1.81,1.8z",
    fill: "#d3dbdc",
    id: "svg_37",
    transform: "matrix(1 0 0 1 0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTableView);
export default __webpack_public_path__ + "static/media/emptyTableView.e2671a0cf2d256952d387a3cce87967a.svg";
export { ForwardRef as ReactComponent };